import { render, staticRenderFns } from "./packageitem.vue?vue&type=template&id=524ae1a4&scoped=true&"
import script from "./packageitem.vue?vue&type=script&lang=js&"
export * from "./packageitem.vue?vue&type=script&lang=js&"
import style0 from "./packageitem.vue?vue&type=style&index=0&id=524ae1a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ae1a4",
  null
  
)

export default component.exports